import store from "@/state/store";
import axios from "axios";

const routes = [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/account/login.vue"),
    meta: {
      title: "Login",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },

  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/account/register.vue"),
    meta: {
      title: "Register",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },

  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("../views/account/forgot-password.vue"),
    meta: {
      title: "Forgot Password",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },

  },
  {
    path: "/",
    name: "default",
    component: () => import("../views/dashboard/ecommerce/index.vue"),
    meta: {
      title: "Dashboard",
      authRequired: true,
    },
  },
  {
    path: "/dashboard/crypto",
    name: "dashboard-crypto",
    meta: {
      title: "Crypto",
      authRequired: true,
    },
    component: () => import("../views/dashboard/crypto/index"),
  },
  {
    path: "/dashboard/projects",
    name: "dashboard-projects",
    meta: {
      title: "Projects",
      authRequired: true,
    },
    component: () => import("../views/dashboard/projects/index"),
  },
  {
    path: "/pages/profile",
    name: "profile",
    meta: { title: "Profile", authRequired: true },
    component: () => import("../views/pages/profile/simple"),
  },
  {
    path: "/dashboard/crm",
    name: "dashboard-crm",
    meta: {
      title: "CRM",
      authRequired: true,
    },
    component: () => import("../views/dashboard/crm/index"),
  },
  {
    path: "/dashboard/analytics",
    name: "dashboard-analytics",
    meta: {
      title: "Analytics",
      authRequired: true,
    },
    component: () => import("../views/dashboard/analytics/index"),
  },
  {
    path: "/dashboard/nft",
    name: "dashboard-nft",
    meta: {
      title: "NFT Dashboard",
      authRequired: true,
    },
    component: () => import("../views/dashboard/nft/index"),
  },
  {
    path: "/dashboard/job",
    name: "dashboard-job",
    meta: {
      title: "Job Dashboard",
      authRequired: true,
    },
    component: () => import("../views/dashboard/job/index"),
  },
  {
    path: "/dashboard/blog",
    name: "dashboard-blog",
    meta: {
      title: "Blog Dashboard",
      authRequired: true,
    },
    component: () => import("../views/dashboard/blog/index"),
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      title: "Logout",
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        const token = localStorage.getItem("jwt");

        if (!token) {
          return next({ name: "login" }); // Langsung ke logout-view jika tidak ada token
        }

        axios
          .post(
                `${process.env.VUE_APP_URL}/auth/logout`,
            {},
            {
              headers: {
                Authorization: `${token}`, // Pastikan format benar dengan "Bearer"
                "Content-Type": "application/json",
              },
            }
          )
          .finally(() => {
            next({ name: "logout-view" }); // Redirect ke halaman logout view setelah logout
          });
      },
    },
  },
  {
    path: "/logout/view",
    name: "logout-view",
    meta: {
      title: "Logout",
      authRequired: false, // Pastikan tidak memerlukan auth agar bisa diakses
    },
    component: () => import("../views/auth/logout/basic"),
  },
  {
    path: "/user/management",
    name: "user",
    meta: { title: "Users", authRequired: true },
    component: () => import("../views/user/list"),
  },
  {
    path: "/schedule/management",
    name: "schedule",
    meta: { title: "Schedules", authRequired: true },
    component: () => import("../views/schedule-management/list"),
  },
  {
    path: "/ud/management",
    name: "ud-management",
    meta: { title: "UD Management", authRequired: true },
    component: () => import("../views/ud-management/list"),
  },
  {
    path: "/schedule/print-sticker",
    name: "print-sticker",
    meta: { title: "Print Sticker", authRequired: true },
    component: () => import("../views/schedule-management/print-sticker"),
  },
  {
    path: "/sample/management",
    name: "sample",
    meta: { title: "Samples", authRequired: true },
    component: () => import("../views/sample/list"),
  },
  {
    path: "/progress/schedule",
    name: "progress-schedule",
    meta: { title: "Progress Schedule", authRequired: true },
    component: () => import("../views/schedule/list"),
  },
  {
    path: "/project/management",
    name: "project",
    meta: { title: "Projects", authRequired: true },
    component: () => import("../views/project/list"),
  },
  {
    path: "/client/management",
    name: "client",
    meta: { title: "Clients", authRequired: true },
    component: () => import("../views/client/list"),
  },
  {
    path: "/inventory/management",
    name: "inventory",
    meta: { title: "Inventory Management", authRequired: true },
    component: () => import("../views/inventory/list"),
  },
  {
    path: "/log/activity",
    name: "log",
    meta: { title: "Log Activity", authRequired: true },
    component: () => import("../views/log/list"),
  },
  {
    path: "/summary",
    name: "summary",
    meta: { title: "Summary Report", authRequired: true },
    component: () => import("../views/summary/list"),
  },
  {
    path: "/price/management",
    name: "price",
    meta: { title: "Price Management", authRequired: true },
    component: () => import("../views/price/list"),
  },
  {
    path: "/role/management",
    name: "role",
    meta: { title: "Roles", authRequired: true },
    component: () => import("../views/role/list"),
  },
   {
    path: "/test/management",
    name: "test",
    meta: { title: "Test Management", authRequired: true },
    component: () => import("../views/test/list"),
  },
   {
    path: "/equipment/management",
    name: "equipment",
    meta: { title: "Equipment Management", authRequired: true },
    component: () => import("../views/equipment/list"),
  },
   {
    path: "/signature/management",
    name: "signature",
    meta: { title: "Signature Management", authRequired: true },
    component: () => import("../views/signature/list"),
  },
    {
    path: "/approval/management",
    name: "approval",
    meta: { title: "Approval Management", authRequired: true },
    component: () => import("../views/approval/list"),
  },
];

export default routes;
